<template>
    <div>
        <b-dropdown :disabled="disableExportButton" id="export-options" class="ml-5" text="Eksportēt">
            <b-dropdown-item-button @click="downloadAllUserWithOVP">Visus darbiniekus</b-dropdown-item-button>
            <b-dropdown-item-button :disabled="disableWaitingForApprovalButton" @click="downloadWaitingForApproval">Gaida apstiprinājumu</b-dropdown-item-button>
        </b-dropdown>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';

    import * as companyStoreTypes from '../../../vuex/modules/company/company.store-types';
    import * as exportStoreTypes from '../../../vuex/modules/exports/export.store-types'

    export default {
        name: 'users-ovp-job-conditions-export',
        components: {  },
        data: () => ({}),
        computed: {
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            disableWaitingForApprovalButton() {
                return !this.currentCompany.users.some((user) => user.ovpJobConditions.some((cond) => cond.waitingForApproval))
            },
            disableExportButton() {
                return !this.currentCompany.users.some((user) => user.ovpJobConditions?.length )
            }
        },
        methods: {
            ...mapActions('export', {
                exportUsersWithOvpStatus: exportStoreTypes.ACTION_EXPORT_USER_OVP_STATUS
            }),
            async downloadAllUserWithOVP() {
               await this.exportUsersWithOvpStatus({companyId: this.currentCompany._id})
            },
            async downloadWaitingForApproval() {
                await this.exportUsersWithOvpStatus({companyId: this.currentCompany._id, onlyWaitingForApproval: true})
                
            },

        },
    }
</script>